import React, { useState, useEffect } from 'react';
import MinimalTourSlider from './MinimalTourSlider';

const TourMessage = ({ message }) => {
  const [tourData, setTourData] = useState(null);

  // Parse tourData if it exists
  useEffect(() => {
    if (message && message.tourData) {
      try {
        // Parse the stringified tourData
        const parsedData = typeof message.tourData === 'string' 
          ? JSON.parse(message.tourData) 
          : message.tourData;
        
        setTourData(parsedData);
      } catch (error) {
        console.error('Error parsing tour data:', error);
      }
    }
  }, [message]);

  return (
    <div className="w-full max-w-3xl mx-auto my-3 bg-white bg-opacity-5 rounded-lg p-3">
      <MinimalTourSlider keywords={tourData?.keywords} />
    </div>
  );
};

export default TourMessage; 